import axios from 'axios'
import { getToken } from '../user/tokens'
import { getSeriesIdFromPayload, addWatchHistoryToPayload, formatHistory, addEpisodeNumbersToPayload, fetchCurrentLanguage } from './helpers';
import Cookies from 'js-cookie';

export const setLoadingPage = fetching => {
  return {
    type: 'FETCHING_PAGE',
    payload: fetching
  };
};

export const fetchPage = (route, langCode, ip, userId) => async (dispatch) => {

  if (userId == null) {
    userId = Cookies.get('vl-user');
  }
  dispatch(setLoadingPage(true));
  var languageCode = ""
  
  if (langCode === "" && window.settings.languages) {
    languageCode = await fetchCurrentLanguage(ip);
    languageCode = window.settings.languages.default.code
    Cookies.set('userLanguageSelection', languageCode)
  } else {
    languageCode = langCode
  }
  const token = await getToken()
  var
    s = window.settings,
    content,
    layout,
    apiUrl = s.apiBaseUrlCached || s.apiBaseUrl,
    contentUrl = apiUrl + s.pageEndpoint
console.log("Content URL")
console.log(contentUrl)
console.log(`${new Date()} Fetching page api data\n`)
  var contentApiHeaders = {
    Authorization: token,
    'x-api-key': s.baseAPIKey,
  }

  if (ip)
    contentApiHeaders['X-Forwarded-For'] = ip

  return axios
    .get(contentUrl, {
      params: {
        path: route,
        site: s.internalName,
        includeContent: true,
        ...(languageCode ? { languageCode } : {})
      },
      headers: contentApiHeaders
    })
    .then(r => {
      console.log(`${new Date()} Fetched page api data\n`)
      content = r.data
      addEpisodeNumbersToPayload(content);

      var layoutUrl = `${s.layoutUrlBase}${s.siteId}/web/${content.id}.json`

      var layoutApiHeaders = ip ? { 'X-Forwarded-For': ip } : {}
      return axios.get(layoutUrl, { headers: layoutApiHeaders }).then(s => layout = s.data)
    })
    // Get watch history for videos if we are on a showpage. This is a hack as the information would ideally be already in the pages API
    // UPDATED: Do it on client side too now
    .then(() => {

      const seriesId = getSeriesIdFromPayload(content);
      if (seriesId && userId && userId !== 'undefined' && userId !== 'null') {
        return axios.get(`${s.apiBaseUrl}/content/video/history/user/${userId}`, {
          headers: contentApiHeaders,
          params: {
            seriesId: seriesId,
            site: s.internalName,
          }
        }).then(history => {
          if (Array.isArray(history.data)) {
            addWatchHistoryToPayload(formatHistory(history.data), content);
          }
        });
      } else {
        return Promise.resolve()
      }

    })
    .then(_ => {
      const payload = {
        title: content.title,
        categoryMap: content.categoryMap,
        metadataMap: content.metadataMap,
        id: content.id,
        modules: content.modules,
        layouts: layout.moduleList,
        styles: layout.pageStyle,
        route: route,
        ip: ip,
        lang: languageCode
      }
      console.log(`${new Date()} Dispatching data\n`)
      dispatch({ type: 'FETCH_PAGE', payload: payload })
      dispatch(setLoadingPage(false));
    })
    .catch(e => {
      dispatch({ type: 'FETCH_PAGE_REJECTED', payload: e.response })
      dispatch(setLoadingPage(false));
    })


}